(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const media = window.matchMedia('(max-width: 749px)');
    let frame = 0;
    const update = () => {
      frame = 0;
      if (!media.matches) return;
      document.querySelectorAll('#header-component header-drawer').forEach((drawer) => {
        const header = drawer.closest('#header-component');
        const bottom = Math.max(0, header.getBoundingClientRect().bottom);
        drawer.style.setProperty('--ducorie-menu-top', `${Math.ceil(bottom + 16)}px`);
      });
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    const resizeObserver = new ResizeObserver(schedule);
    const observeHeaders = () => {
      resizeObserver.disconnect();
      document.querySelectorAll('#header-component').forEach((header) => resizeObserver.observe(header));
      schedule();
    };
    document.addEventListener('toggle', (event) => {
      if (event.target.matches?.('.menu-drawer-container')) update();
    }, true);
    document.addEventListener('click', (event) => {
      if (event.target.closest?.('header-drawer > details > summary')) update();
    }, true);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', () => {
      if (document.querySelector('header-drawer > details[open]')) schedule();
    }, { passive: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    media.addEventListener('change', schedule);
    document.addEventListener('shopify:section:load', observeHeaders);
    document.addEventListener('shopify:section:unload', observeHeaders);
    observeHeaders();
  })();
  } catch(e) { console.error(e); }
})();

})();
